import { ButtonBase } from '@mui/material';
import { Divider, Stack, styled, Text } from 'shell/components';

const FileSelector = ({ submission, selectedFileId, onClick }) => {
    return (
        <RootStack
            alignItems={'center'}
            direction={'row'}
            divider={<Divider sx={{ maxHeight: '32px' }} orientation={'vertical'} />}
        >
            {submission.files.map((file) => {
                return (
                    <CustomButtonBase
                        key={file.id ?? file.key}
                        active={file.id === selectedFileId}
                        onClick={() => onClick(file)}
                    >
                        <Text color={'inherit'} noWrap title={file.name}>
                            {file.name}
                        </Text>
                    </CustomButtonBase>
                );
            })}
        </RootStack>
    );
};

const RootStack = styled(Stack)(({ theme }) => {
    return {
        position: 'absolute',
        bottom: 0,
        zIndex: 2,
        borderTop: `1px solid ${theme.palette.ensightful.neutral[300]}`,
        width: '100%',
        height: '44px',
        padding: theme.spacing(1, 2),
        background: theme.palette.ensightful.shades[0],
        overflow: 'auto',
    };
});

const CustomButtonBase = styled(ButtonBase)(({ theme, active }) => {
    return {
        flex: 1,
        minWidth: '100px',
        boxSizing: 'content-box',
        height: '16px',
        padding: theme.spacing(2, 1),
        background: theme.palette.ensightful.neutral[100],
        color: theme.palette.ensightful.neutral[700],
        '&:hover': {
            background: theme.palette.ensightful.neutral[300],
        },
        '&:active': {
            background: theme.palette.ensightful.neutral[400],
        },
        '&:focus-visible': {
            outline: `${theme.palette.ensightful.secondary[400]} solid 3px`,
            outlineOffset: '-5px',
        },
        ...(active && {
            borderTop: `3px solid ${theme.palette.ensightful.primary[500]}`,
            borderTopLeftRadius: '4px',
            borderTopRightRadius: '4px',
            marginTop: '-3px',
            background: theme.palette.ensightful.shades[0],
        }),
    };
});

export default FileSelector;
